import { render, staticRenderFns } from "./landingClaveSii.vue?vue&type=template&id=5b43a1be&scoped=true&"
import script from "./landingClaveSii.vue?vue&type=script&lang=ts&"
export * from "./landingClaveSii.vue?vue&type=script&lang=ts&"
import style0 from "./landingClaveSii.vue?vue&type=style&index=0&id=5b43a1be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b43a1be",
  null
  
)

export default component.exports